import React, { FC } from 'react';
import { AppContext } from '../../Context/app-state';
import { EColors, EShape, ESizes, TToy } from '../../Data/data';
import './Toy.css';

interface IProps {
  options: TToy;
}

const Toy: FC<IProps> = ({ options }) => {
  const { chosens, setChosenToy } = React.useContext(AppContext);

  const handleDiv = (event: React.MouseEvent<HTMLElement>) => {
    const value = (event.target as Element).id;
    if (!chosens.includes(value) && chosens.length <= 20) {
      setChosenToy([...chosens, value]);
    } else {
      const index = chosens.indexOf(value);
      const newChosens = [...chosens];
      newChosens.splice(index, 1);
      setChosenToy(newChosens);
    }
  };
  const { num, name, count, year, shape, color, size, favorite } = options;
  return (
    <div className="App-toy" key={num} id={num} onClick={handleDiv}>
      <h2 className="App-toy__name">{name}</h2>
      <div className="App-toy__img">
        <img src={`./assets/toys/${num}.png`} alt="toy" />
      </div>
      <div className="App-toy__info">
        <div>
          <p>
            Количество: <span>{count}</span>{' '}
          </p>
        </div>
        <div>
          <p>Год покупки: {year} </p>
        </div>
        <div>
          <p>Форма: {EShape[shape]}</p>
        </div>
        <div>
          <p>Цвет: {EColors[color]}</p>
        </div>
        <div>
          <p> Размер: {ESizes[size]}</p>
        </div>
        <div>
          <p>Любимая: {favorite ? 'Да' : 'Нет'}</p>
        </div>
        <div />
      </div>
      <div
        key={num}
        id={num}
        className="App-toy__ribbon"
        onClick={handleDiv}
        style={{
          background: `${chosens.includes(num) ? '#ccb77a' : '#24C5DB'}`,
        }}
      />
    </div>
  );
};
export default Toy;
